module.exports = __webpack_public_path__ + "static/media/gogo.e71da1d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/gogo.png
// module id = 1152
// module chunks = 0